var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"icon-button"},_vm.$listeners),[_c('span',{staticClass:"custom-icon icon-button__icon icon-cross-graphite"})])}
var staticRenderFns = []

export { render, staticRenderFns }